import type { SseGenerator } from '../types';

/**
 * 分段翻译结果
 */
export interface TranslateSegment {
    /**
     * 原始文本
     */
    original: string;
    /**
     * 翻译文本
     */
    translation: string;
}

/**
 * 获取分段翻译结果的能力
 */
export interface GetTranslateSegmentsService extends SseGenerator {
    /**
     * 获取分段翻译结果
     * @param taskId 任务ID
     * @returns
     */
    getTranslateSegments: (taskId: string) => Promise<void>;
}

export const GetTranslateSegmentsService = Symbol('GetTranslateSegmentsService');
